// extracted by mini-css-extract-plugin
export default {"name":"styles_name__97LHw","name_empty":"styles_name_empty__2O1b8","input_name":"styles_input_name__ZU9a4","block_inline":"styles_block_inline__EwE-4","block":"styles_block__i9NoP"};